import { render } from "./DateTimeRenderer.vue?vue&type=template&id=59c57910"
import script from "./DateTimeRenderer.vue?vue&type=script&lang=ts"
export * from "./DateTimeRenderer.vue?vue&type=script&lang=ts"
script.render = render

export default script